import { Component, effect, inject, input, model, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxFileUploaderModule, DxFormModule } from 'devextreme-angular';
import { FormService } from 'src/app/services/form.service';
import { CardComponent } from '../library/card/card.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-form-attachment',
    imports: [CommonModule, DxFileUploaderModule, CardComponent, DxFormModule, DxButtonModule],
    template: `
    <card class="profile-card full-card">
      <dx-form class="form last plain-styled-form" labelMode="outside" [showColonAfterLabel]="false">
        <dxi-item [label]="{ text: 'Upload Consent' }">
          <div *dxTemplate>
            @if (isEditing()) {
            <dx-file-uploader
              selectButtonText="Select a PDF"
              labelText="or Drop a PDF here"
              accept=".pdf"
              [allowedFileExtensions]="['.pdf']"
              [uploadMode]="'useForm'"
              [(value)]="files"
              [multiple]="false"
            ></dx-file-uploader>
            <div class="description">
              To complete your referral request quickly, please upload a signed PDF consent form. This form authorizes us to share
              information with the appropriate provider.
            </div>
            } @else if (attachmentId()) {
            <dx-button text="View Consent file" (onClick)="viewAttachment()" class="view-button"></dx-button>
            } @else {
            <div class="description">No consent form uploaded</div>
            }
          </div>
        </dxi-item>
      </dx-form>
    </card>
  `,
    styles: [
        `
      :host {
        display: contents;
      }

      .profile-card {
        flex: 0.5;
      }

      .description {
        font-size: 12px;
      }

      .view-button {
        margin-top: 10px;
      }
    `
    ]
})
export class FormAttachmentComponent {
  formService = inject(FormService);

  formName = input.required<string>();
  formId = input<number>(null);
  isEditing = input<boolean>(false);

  attachmentId = signal<number | null>(null);

  files = signal<File[]>([]);

  constructor() {
    effect(
      async () => {
        if (!this.isEditing() && this.formId()) {
          const attachment = await this.formService.get<any>(FormService.Forms.Attachment, this.formId());
          if (attachment) {
            this.attachmentId.set(attachment.id);
          }
        } else {
          this.attachmentId.set(null);
        }
      },
      { allowSignalWrites: true }
    );
  }

  async submit(formId: number) {
    if (this.files().length === 0) {
      console.log('No file to upload');
      return;
    }
    const file = this.files()[0];
    formId = formId || this.formId();
    await this.formService.postAttachment(this.formName(), formId.toString(), file);
  }

  viewAttachment() {
    window.open(`${environment.serviceUrl}/forms/attachment/open/${this.attachmentId()}`);
  }
}
